module.exports = __webpack_public_path__ + "images/vr-headset-f941b3aeac192eb266708a9b0fb759ab.svg";